import { TextAreaProps } from 'antd/lib/input';
import { StyledTextArea } from './TextArea.styles';

const TextArea = (props: TextAreaProps) => <StyledTextArea {...props}></StyledTextArea>;
export default TextArea;
